import cx from "classnames";

import Box from "ds/components/Box";

import styles from "./styles.module.css";

type TableWrapperProps = {
  children: React.ReactNode;
  className?: string;
  fullPage?: boolean;
  paginationSlot?: React.ReactNode;
  style?: React.CSSProperties;
  virtualizedListContainerRef: React.RefObject<HTMLDivElement | null>;
};

/**
 * @deprecated Use the DS TableWrapper component instead
 */
const TableWrapper = ({
  children,
  className,
  fullPage = true,
  paginationSlot,
  style = {},
  virtualizedListContainerRef,
}: TableWrapperProps) => {
  return (
    <Box
      direction="column"
      zeroMinWidth
      justify="between"
      className={cx(styles.contentWrapper, className)}
      style={{
        height: fullPage
          ? `calc(100vh - ${virtualizedListContainerRef.current?.getBoundingClientRect().top}px)`
          : "auto",
        ...style,
      }}
    >
      <Box className={cx(styles.tableWrapper, { [styles.hasPagination]: !!paginationSlot })}>
        {children}
      </Box>
      {paginationSlot}
    </Box>
  );
};

export default TableWrapper;
